import { Box, LinearProgress, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

const CustomLinearProgress = styled(LinearProgress)(({ theme }: any) => ({
  height: 5,
  borderRadius: 5,
  backgroundColor: "rgba(0, 0, 0, 0.1)",
  "& .MuiLinearProgress-bar": {
    backgroundColor: theme.palette.primary.main,
  },
}));

const LinearProgressTodo = ({ progress, width }: any) => {
  const { t } = useTranslation("common");
  return (
    <div>
      <Box sx={{ mb: 1 }} display="flex" alignItems="center">
        <Typography variant="body1" color="#65676D">
          {t("todo.tasks_performed")}:{" "}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontWeight: "bold",
            ml: 1,
          }}
        >
          <Box component="span" sx={{ color: "primary.main" }}>
            {progress.current}
          </Box>
          /{progress.total}
        </Typography>
      </Box>
      <Box sx={{ width: "100%", mb: 1 }}>
        <CustomLinearProgress
          variant="determinate"
          value={(progress.current / progress.total) * 100}
          sx={{ width: width || "100%" }}
        />
      </Box>
    </div>
  );
};

export default LinearProgressTodo;
